import { render } from "./App.vue?vue&type=template&id=c54ab606"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c54ab606&lang=css"

import exportComponent from "/Users/elhazent/Downloads/wedding-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__